import cx from 'classnames'
import PropTypes from 'prop-types'

import RatingFeature, {ratingFeatureSizes, ratingFeatureTypes} from '@adv-mt/mt-rating-feature'

import {BASE_CLASS, LAYOUTS, MAX_SCORE} from './settings.js'

function PanelRating({rating = [], withoutOverallRating = false, maxScore = MAX_SCORE, layout = LAYOUTS.HORIZONTAL}) {
  const overallRating = rating.find(({type}) => type === 'overall')
  const hasOverallRating = !!overallRating && !withoutOverallRating
  const ratingAggregates = rating.filter(({type}) => type !== 'overall')

  const classNameFeaturesWrapper = cx(`${BASE_CLASS}-featuresWrapper`, {
    [`${BASE_CLASS}-featuresWrapper--horizontal`]: layout === LAYOUTS.HORIZONTAL && hasOverallRating
  })

  const trailingIndicator = `/${maxScore}`

  return (
    <div className={BASE_CLASS}>
      <div className={classNameFeaturesWrapper}>
        {hasOverallRating && !withoutOverallRating && (
          <div className={`${BASE_CLASS}-features ${BASE_CLASS}-features--center`}>
            <RatingFeature
              maxScore={maxScore}
              rating={overallRating.score}
              size={ratingFeatureSizes.EXTRA_LARGE}
              type={ratingFeatureTypes.CIRCLE}
            />
          </div>
        )}
        <ul className={`${BASE_CLASS}-features`}>
          {ratingAggregates.map(({label, score, type}) => (
            <li key={type}>
              <RatingFeature
                indicatorTrailing={trailingIndicator}
                label={label}
                maxScore={maxScore}
                rating={score}
                size={ratingFeatureSizes.MEDIUM}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

PanelRating.displayName = 'PanelRating'
PanelRating.propTypes = {
  maxScore: PropTypes.number,
  rating: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      type: PropTypes.string,
      score: PropTypes.number
    })
  ),
  layout: PropTypes.oneOf(Object.values(LAYOUTS)),
  withoutOverallRating: PropTypes.bool
}

export default PanelRating
export {LAYOUTS as panelRatingLayouts}
